import { createAction, props, union } from '@ngrx/store';
import { RelSaveQueryI } from '../../api/rel-save/rel-save.query.int';
import { RelSaveResponseI } from '../../api/rel-save/rel-save.query.result.int';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
/* eslint-disable max-len */

export const error = createAction('[REL / Save] Error', props<{
  messageText: string;
  pageType: SharedPageTypeEnum;
}>());
export const reset = createAction('[REL / Save] Reset', props<{
  pageType: SharedPageTypeEnum;
}>());
export const load = createAction('[REL / Save] Get', props<{
  query: RelSaveQueryI;
  pageType: SharedPageTypeEnum;
}>());
export const received = createAction('[REL / Save] Received', props<{
  data: RelSaveResponseI;
  pageType: SharedPageTypeEnum;
}>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
